import { useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth.jsx'
import { useAccess } from '../lib/access.jsx'
import { NAV } from '../nav.js'
import { IconLogout } from './icons.jsx'
import styles from './TopBar.module.css'
import { buildDetail, displayVersion } from '../lib/buildInfo.js'

function titleFor(pathname) {
  if (pathname === '/') return 'Home'
  const match = NAV.find((n) => n.to !== '/' && pathname.startsWith(n.to))
  return match ? match.label : 'Platform'
}

function initials(user) {
  const name = user?.name || user?.username || user?.email || 'SR'
  return name
    .split(/[\s@._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join('')
}

export default function TopBar({ onMenu, navOpen=false, menuRef }) {
  const { user, logout } = useAuth()
  const { roleMeta, roleSource, hasRealRole } = useAccess()
  const { pathname } = useLocation()
  const current = titleFor(pathname)
  const displayName = user?.name || user?.username || user?.email || 'Representative'

  return (
    <header className={styles.bar}>
      <button ref={menuRef} className={styles.menu} onClick={onMenu} aria-label="Toggle navigation" aria-expanded={navOpen} aria-controls="platform-navigation">
        ☰
      </button>

      <div className={styles.crumbs}>
        {/* Canonical SR mark — owned in-repo (public/brand), never hot-linked. */}
        <img className={styles.crumbMark} src="/brand/sr-monogram.png" alt="Southern Recognition" width="20" height="20" />
        <span className={styles.crumbRoot}>SR</span>
        <span className={styles.crumbSep}>/</span>
        <span className={styles.crumbCurrent}>{current}</span>
      </div>

      <div className={styles.spacer} />

      <span className={styles.release} aria-label="Current app version" title={buildDetail()}>{displayVersion()}</span>
      <span className={styles.env}>Production</span>

      {/* Which permission lane this session is in. `roleSource` is the honest
          part: 'session' means the backend never sent a role. */}
      <span
        className={styles.role}
        data-real={hasRealRole}
        title={
          hasRealRole
            ? `${roleMeta?.blurb} (source: ${roleSource})`
            : 'No role on this session — the backend does not assign one yet, so account control is disabled.'
        }
      >
        {roleMeta?.label}
        {roleSource === 'preview' && <em className={styles.rolePreview}>preview</em>}
      </span>

      <div className={styles.user}>
        <div className={styles.avatar} aria-hidden="true">
          {initials(user)}
        </div>
        <span className={styles.uname}>{displayName}</span>
        <button className={styles.logout} onClick={logout} aria-label="Sign out">
          <IconLogout width={16} height={16} />
        </button>
      </div>
    </header>
  )
}
